import { Component, Input, OnInit } from '@angular/core';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';

@Component({
  selector: 'usb-tooltip-convert-amount',
  templateUrl: './tooltip-convert-amount.component.html',
  styleUrls: ['./tooltip-convert-amount.component.scss']
})
export class TooltipConvertAmountComponent implements OnInit {
  @Input() clientsSettingAppBooking: any;
  @Input() currencyProduct: any;
  @Input() valueProduct: any;

  public currencies: any[] = [];
  public currencyAgency: any;
  public isTooltipOpen = false;

  public overlayPositions: ConnectedPosition[] = [
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetY: 8 },
    { originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom', offsetY: -8 },
    { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top', offsetY: 8 },
    { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom', offsetY: -8 }
  ];

  constructor(private userService: UserService) { }

  ngOnInit(): void {

    this.currencies = this.userService.currenciesExchange;
    const selectedAgency = JSON.parse(localStorage.getItem('selectedAgency'));
    this.currencyAgency = this.currencies.find(c => c.code === selectedAgency.currency);

  }

}
